// Shared geo helpers for the Fliteschool directory + region locations grid.
// Plain global, no modules/build step: window.FBGeo = { distanceKm, reorder }.
// Load this via <script defer> BEFORE either consumer script in its section.
(function () {
  // Haversine — returns kilometres between two lat/lng pairs.
  function distanceKm(aLat, aLng, bLat, bLng) {
    const R = 6371;
    const toRad = (deg) => (deg * Math.PI) / 180;
    const dLat = toRad(bLat - aLat);
    const dLng = toRad(bLng - aLng);
    const s =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
    return 2 * R * Math.asin(Math.sqrt(s));
  }

  // Reorders a grid's direct <li> cards nearest-first by distance to the user.
  // Cards without valid coords sort to the bottom (Infinity distance), keeping
  // their original relative order via a stable sort.
  function reorder(grid, userLat, userLng) {
    const items = Array.from(grid.querySelectorAll(':scope > li[data-location-handle]'));
    const ranked = items.map((li) => {
      const lat = parseFloat(li.dataset.lat);
      const lng = parseFloat(li.dataset.lng);
      const valid = Number.isFinite(lat) && Number.isFinite(lng);
      return { li, distance: valid ? distanceKm(userLat, userLng, lat, lng) : Infinity };
    });
    ranked.sort((a, b) => a.distance - b.distance);
    const frag = document.createDocumentFragment();
    ranked.forEach(({ li }) => frag.appendChild(li));
    grid.appendChild(frag);
  }

  window.FBGeo = { distanceKm, reorder };
})();
